import http from './index'

export default {
  // 获取用户行为数据
  getBehaviorData (params) {
    return http.get('/front/userBehavior/menuVisitOverview', params)
  },
  // 获取趋势图数据
  getTrendData (params) {
    return http.get('/front/userBehavior/menuVisitStatics', params)
  },
  // 获取组件访问次数
  componentVisitOverview (params) {
    return http.get('/front/userBehavior/componentVisitOverview', params)
  }
}
